import { createSafeContext } from '@sgme/react';
import { ReactNode } from 'react';
import { Streaming } from 'utils/streaming/model';

interface StreamingContextValue extends Streaming {}
const [Provider, contextAccessor] = createSafeContext<StreamingContextValue>('streaming');
interface Props {
  streaming: Streaming;
  children: ReactNode;
}
export function StreamingProvider({ streaming, children }: Props) {
  return <Provider value={streaming}> {children}</Provider>;
}

export const useStreamingContext = contextAccessor;
